import AppleSignin from 'react-apple-signin-auth';

//
//  Response object example
//  {authorization: {code: 'abc', id_token: 'def'}}

const url = `${window.location.href.replace(/\?.*/, '')}api/v1/users/auth/apple/callback`;
let clientName = '';
if (window.location.href.indexOf('staging') !== -1) {
  clientName = 'staging';
} else if (window.location.href.indexOf('app.activist') !== -1) {
  clientName = 'app-services';
} else {
  clientName = 'dev';
}
const clientId = `com.activistmailer.${clientName}`;
console.log(" CLIENT ID IS: " + clientId);
console.log('URL: ' + url + '  ClientID: ' + clientId);
/** Apple Signin button */
const AppleLoginButton = ({performAppleAuth}) => (
  <div style={{marginTop: '12px', width: '192px', borderRadius: '12px', display: 'flex', flexDirection: 'column', alignSelf: 'center'}}>
  <AppleSignin
    /** Auth options passed to AppleID.auth.init() */
    authOptions={{
      /** Client ID - eg: 'com.example.com' */
      clientId: clientId,
      /** Requested scopes, seperated by spaces - eg: 'email name' */
      scope: 'email name',
      /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
      redirectURI: url,
      /** State string that is returned with the apple response */
      state: '',
      /** Nonce */
      nonce: new Date().getTime().toString(),
      /** Uses popup auth instead of redirection */
      usePopup: true
    }} // REQUIRED
    /** General props */
    uiType="dark"
    /** className */
    className="apple-auth-btn"
    /** Removes default style tag */
    noDefaultStyle={false}
    /** Allows to change the button's children, eg: for changing the button text */
    buttonExtraChildren={<span style={{fontSize: '14px'}}>Sign in with Apple</span>}
    /** Extra controlling props */
    /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
    onSuccess={(response) => {console.log(JSON.stringify(response)); performAppleAuth(response)}} // default = undefined
    /** Called upon signin error */
    onError={(error) => console.error(error)} // default = undefined
    /** Skips loading the apple script if true */
    skipScript={false} // default = undefined
    /** Apple image props */
    iconProp={{ style: { marginTop: '10px' } }} // default = undefined
    /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
    /** render={(props) => <button {...props}>My Custom Button</button>} **/
  />
  </div>
);

export default AppleLoginButton;
